<template>
  <subgame3Dian8 v-if="$store.state.config.ui_version == '3.8'"></subgame3Dian8>
  <subgame v-else></subgame>
</template>

<script>
import subgame3Dian8 from './subgame3.8.vue';
import subgame from './subgame.vue';
export default {
  components: {
    subgame3Dian8,
    subgame
  }
};
</script>
